<template>
    <div class="">
        <div class="room__collapse accordion" id="accordionExample">
            <div class="card">
                <div class="card-header p-0" id="headingOne">
                    <button class="room__collapse__header" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        Room Task Advanced Search
                        <svg xmlns="http://www.w3.org/2000/svg" width="9.414" height="5.414" viewBox="0 0 9.414 5.414" class="arrow__collapsible">
                        <g id="Grupo_6049" data-name="Grupo 6049" transform="translate(8.707 4.707) rotate(180)">
                            <line id="Línea_794" data-name="Línea 794" x2="4" y2="4" transform="translate(4)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1"/>
                            <line id="Línea_795" data-name="Línea 795" x1="4" y2="4" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1"/>
                        </g>
                        </svg>
                    </button>
                </div>
                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                    <div class="card-body">
                        <h1 class="view__title title--1" v-html="title_page"/>
                        <LocalFormSearch
                        :form_data="form_data"
                        :form_format="form_format"
                        :array_options="array_options"
                        :boolean_options="boolean_options"
                        :radio_options="radio_options"
                        :radio_room_state_options="radio_room_state_options"
                        :simbol_options="simbol_options"
                        :excl_options="excl_options"
                        @debounceInput="debounceInput"
                        @resetList="applySearch"
                        :filter_options="filter_options"
                    />
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-12 pt-0">
            <slot name="overtable"></slot>
            <v-card>
                <DinamicTableInfiniteLoader
                    :name="'AdvancedSearch'"
                    :selectable_columns="true"
                    :array_options_table="(use_parent) ? parent_array_options_table : array_options_table"
                    :headers="(table_headers && table_headers.length) ? table_headers : local_table_headers"
                    :items="(use_parent) ? parent_room_tasks :room_tasks"
                    :pagination="(use_parent) ? parent_pagination :pagination"
                    :search="search"
                    :checkable="true"
                    :link="child_href"
                    :size="30"
                    :historiable="historiable"
                    :updateable="updateable"
                    :autoincrement="autoincrement"
                    :detail_text="detail_text"
                    @emitToUpdate="$emit('modal_update', $event)"
                    @fetchMainList="fetchMainList($event)"
                    @history="$emit('history', $event)"
                    @paginateMoreRecords="paginateMoreRecords($event)"
                    ref="main_table"
                />
            </v-card>
        </div>

        <WaitingModal v-if="checkeable === undefined && !checkeable"/>
    </div>
</template>

<script>

import Resources        from    './resources'
import FormResources    from    './form_resources'
import WaitingModal     from    '@/components/WaitingModal'
import DinamicTableInfiniteLoader     from    '@/components/DinamicTableInfiniteLoader'
import LocalFormSearch  from    './LocalFormSearch'
import Methods          from    './methods'
import { Notyf }        from    'notyf'
import _ from 'lodash'
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: 'RoomTaskAdvancedSearch',

    props:[
        'parent_room_tasks',
        'parent_pagination',
        'parent_array_options_table',
        'use_parent',
        'detail_text',
        'checkeable',
        'rest_api',
        'rest_api_pagination',
        'historiable',
        'updateable',
        'autoincrement',
        'table_headers',
        'search',
        'filter_options',
        'default_filters',
        'module_name'
    ],

    components:{
        WaitingModal,
        LocalFormSearch,
        DinamicTableInfiniteLoader,
    },

    mixins:[
        Methods,
    ],

    data(){
        return{
            notyf,
            title_page:                 'Advanced search',
            child_href:                 '/building-room/',
            rest_api_search:            'rooms_advanced_search',
            local_table_headers:        Resources.table_headers,
            breadcrumb:                 Resources.breadcrumb,
            form_data:                  FormResources.form_data,
            form_format:                FormResources.form_format,
            radio_options:              FormResources.radio_options,
            radio_room_state_options:   FormResources.radio_room_state_options,
            boolean_options:            Resources.boolean_options,
            status_options:             Resources.status_options,
            excl_options:               Resources.excl_options,
            simbol_options:             Resources.simbol_options,
            shift_criteria_options:     Resources.shift_criteria_options,
            room_tasks:                 [],
            array_options:              {},
            selectAll:                  false,
            tasks: [],
            pagination: null,
            array_options_table: [],
            first_time_search: true

        }
    },

    methods:{

        debounceInput:  _.debounce(function (e)  {
            this.form_data[e.field] = e.value
        }, 0),


        checkingOrigins(room_tasks_origin_id)
        {
            room_tasks_origin_id.forEach(origin_id => 
            {
                let indexFound = this.room_tasks.findIndex(room => room.origin_id === origin_id)
                
                if(indexFound > -1)
                {
                    this.room_tasks[indexFound].checked = true
                    window.$(`#advancedItems${indexFound}`).prop('checked', true)
                }
            })
        },
        replacingRoomTasks(room_tasks)
        {
            room_tasks.forEach(updated_room => {

                let found_index = this.room_tasks.findIndex(room => room.origin_id === updated_room.origin_id)
                if(found_index > -1)
                {
                    updated_room.checked = true;
                    this.room_tasks.splice(found_index, 1, updated_room)
                }
            })
        },

        removingRoomTasks(room_tasks, is_array_id = false)
        {
            room_tasks.forEach(updated_room => {
                
                let found_index = -1
                
                if(is_array_id)
                {
                    found_index = this.room_tasks.findIndex(room => room.room_task_id === updated_room)
                }
                else
                {
                    found_index = this.room_tasks.findIndex(room => room.room_task_id === updated_room.room_task_id)
                }

                if(found_index > -1)
                {
                    this.room_tasks.splice(found_index, 1)
                }
            })

            this.pagination.total -= room_tasks.length
            this.pagination.total = this.pagination.total < 0 ? 0 : this.pagination.total
        },

        async paginateMoreRecords(params)
        {
            if(this.use_parent)
            {
                this.$emit('paginateMoreRecordsParent', params)

                return;
            }

            if(this.room_tasks.length >= this.pagination?.total)
            {
                return;
            }
            
            await this.showLoader()

            await this.apiRequest(params)
        },

        async fetchMainList(params) 
        {
            if(this.use_parent)
            {
                this.$emit('fetchMainListParent', params)

                return;
            }
            this.room_tasks = [];
            await this.showLoader()
            await this.apiRequest(params, true)
        },


        async loadMoreRecords(data, reset_list)
        {
            if(reset_list)
            {
                this.room_tasks = []
            }

            if(data.pagination.data.length)
            {
                data.pagination.data.forEach((item) => {
                    item.checked = this.$refs.main_table.select_all
                    this.room_tasks.push(item)
                })
            }
            this.pagination = data.pagination

            this.$emit('passData', data.options || null)

            // eventBus.$emit('hideToast')

            await this.hideLoader(data.pagination.data)
        },

        async showLoader()
        {
            this.$refs.main_table.showLoader()
        },

        async hideLoader(data)
        {
            this.$refs.main_table.hideLoader(data)
        },
        resetSelectAll()
        {
            this.$refs.main_table.resetSelectAll()
        }



    },

    async mounted()
    {
        this.form_data.module_name = this.module_name
        // eventBus.$on('applySearch', () => 
        // {
        //     this.applySearch()
        // })

        await this.api_request()

        // eventBus.$emit('showToast', true)

        this.firstRequest()
        
    },

    computed: 
    {
        selected()
        {
            const bool = this.room_tasks.filter(item => item.checked)
            return Boolean(bool.length)
        },
        
    }

}

</script>